interface CloudinaryTransformations {
  width: number;
  /** Do not use height to preserve aspect ratio */
  height?: number;
  g_face?: boolean;
}

const defaultTransformations = "q_auto,f_avif";

export const applyCloudinaryTransformations = ({
  src,
  transformations,
}: {
  src?: string;
  transformations: CloudinaryTransformations;
}): string | undefined => {
  if (!src?.includes("cloudinary")) {
    return src;
  }

  const { width, height, g_face } = transformations;

  const transformationArray = [
    defaultTransformations,
    `w_${width}`,
    height ? `h_${height}` : "",
    g_face ? `g_face` : "",
    g_face ? "c_thumb" : "",
  ];

  const transformationString = transformationArray.filter(Boolean).join(",");
  const newSrc = src.replace(
    "/image/upload/",
    `/image/upload/${transformationString}/`
  );
  return newSrc;
};
